import StandaloneApp from './StandaloneApp';
import IntegrationApp from './IntegrationApp';

// using var here so the variable is added to window scope
window.app = null;

(async () => {
    document.addEventListener("DOMContentLoaded", async () => {
        if (window.jsModuleSettings.useVConsole === 'true') {
            const VConsole = await import('vconsole');
            const vConsole = new VConsole.default();
            console.log(`VConsole ${vConsole.isInited}`);
        }

        if (window.hfStartOptions.jsApiEnabled) {
            app = new IntegrationApp();
        } else {
            app = new StandaloneApp();
        }

        const isInitialized = await app.init();

        if (isInitialized) {
            await app.run();
        }
    }, false);
})();